<div class="main-container">
    <app-page-header pageTitle="Alumni Request"></app-page-header>

    <ng-container *ngIf="show === null; else alumniPage">
        <app-user-page-loader label="Loading alumni request information"></app-user-page-loader>
    </ng-container>

    <ng-template #alumniPage>
    <div class="card-container"
        *ngIf="show && status == 'ACTIVE_MCT' && (alumniStatus == null || alumniStatus == 'NONE') ">
        <mat-card class="renewal-card" aria-labelledby="short-card-title" appearance="outlined">

            <form [formGroup]="alumniForm" (ngSubmit)="submit()">
                <div class="formTitle">
                    Alumni Request
                </div>

                <div>
                    <mat-form-field>
                        <input type="text" placeholder="First Name*" matInput formControlName="firstname" />
                        <mat-error
                            *ngIf="!alumniForm.get('firstname')?.valid && alumniForm.get('firstname')?.touched && alumniForm.get('firstname')?.errors?.required">
                            First name is required</mat-error>
                        <mat-error
                            *ngIf="alumniForm.get('firstname')?.touched && alumniForm.get('firstname')?.errors?.pattern">
                            First name can contain letters only</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <input type="text" placeholder="Last Name*" matInput formControlName="lastname" />
                        <mat-error
                            *ngIf="!alumniForm.get('lastname')?.valid && alumniForm.get('lastname')?.touched && alumniForm.get('lastname')?.errors?.required">
                            Last name is required</mat-error>
                        <mat-error
                            *ngIf="alumniForm.get('lastname')?.touched && alumniForm.get('lastname')?.errors?.pattern">
                            Last name can contain letters only</mat-error>
                    </mat-form-field>

                    <mat-form-field>
                        <input type="text" placeholder="Email*" matInput formControlName="email" />
                        <mat-error
                            *ngIf="alumniForm.get('email')?.touched && alumniForm.get('email')?.errors?.required">
                            Email is required</mat-error>
                    </mat-form-field>



                    <div>
                        <span class="concent_label">Current Subscription</span>
                        <div class="subscription-details">
                            <div>
                                <p>ACTIVE SINCE</p>
                                <p>{{activeSince ? (activeSince | date:'MMMM dd, yyyy':'UTC' ): '-'}}</p>
                            </div>
                            <div>
                                <p>END DATE</p>
                                <p>{{endDate ? (endDate | date:'MMMM dd, yyyy':'UTC' ): '-'}}</p>
                            </div>
                        </div>
                    </div>

                    <div class="checkbox-section-wrapper">
                        <span class="concent_label">What prompted your transition to the Alumni program?</span>
                        <p class="reason-description">
                            Your feedback matters. Please share your reason(s) for switching to the MCT Alumni program.
                            <br /> Please Note: MCT Alumni benefits differ from the benefits provided to MCTs. Please
                            click here to <a
                                href="https://learn.microsoft.com/en-us/credentials/certifications/mct-certification#mct-alumni-program"
                                target="_blank" rel="noopener noreferrer">learn more</a>
                        </p>
                        <div class="checkbox-container">
                            <mat-checkbox *ngFor="let reason of reasonOptions"
                                [checked]="isReasonSelected(reason.value)"
                                (change)="onReasonChange($event, reason.value)" class="checkbox-item">
                                {{reason.label}}
                            </mat-checkbox>
                        </div>
                        <mat-error
                            *ngIf="alumniReasonsControl?.invalid && (alumniReasonsControl?.dirty || alumniReasonsControl?.touched)">
                            Please select at least one reason for becoming an alumni
                        </mat-error>
                    </div>

                    <div>
                        <mat-form-field>
                            <textarea matInput placeholder="Description" #textarea maxlength="500"
                                formControlName="alumniText"></textarea>
                            <mat-hint align="end">{{ textarea.value.length }} / 500</mat-hint>
                            <mat-error
                                *ngIf="!alumniForm.get('alumniText')?.valid && alumniForm.get('alumniText')?.touched && alumniForm.get('alumniText')?.errors?.['required']">
                                Description is required
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="aggrement-container">
                         <p class="agreement-note">
                            <em>Note: You must review the MCT Alumni Agreement through the link below before you can check the box to accept it.</em>
                         </p>
                        <div class="checkbox-horizontal-container">
                            <mat-checkbox class="checkbox-item" formControlName="mctAlumniAgreement"
                                [(ngModel)]="isCheckboxSelected" [ngClass]="{
                                        'is-invalid': !isCheckboxSelected && formSubmitted }" id="alumniCheckbox">
                            </mat-checkbox>
                             By checking this box, I acknowledge that I have read and agree to the terms of the <a class="hyperlink" href="javascript:void(0)" (click)="agrementDoc()" (keydown.enter)="agrementDoc(); $event.stopPropagation()" [attr.aria-label]="'MCT Alumni Agreement (downloads PDF file, 150KB)'">MCT Alumni Agreement</a>
                        </div>
                        <mat-error class="is-invalid no-top-margin" *ngIf="!isCheckboxSelected && formSubmitted">
                            You must accept the Agreement to continue
                        </mat-error>
                    </div>
                </div>

                <div class="btn-submit-container">
                    <button type="button" class="cancelButton" mat-stroked-button>
                        Cancel
                    </button>

                    <button type="button" class="submitButton" mat-flat-button (click)="submit()">
                        Submit
                    </button>
                </div>
            </form>
        </mat-card>

        <div class="renewal-details">
            <mat-card aria-labelledby="short-card-title" appearance="outlined">
                <div class="card-split-container">
                    <div class="card-left-section">
                        <span>
                            <p class="section-title">MCT</p>
                            <p class="section-subtitle">MCT Fee</p>
                        </span>
                        <ul class="feature-list">
                            <li class="feature-item">
                                <mat-icon class="checkmark-icon">check</mat-icon>
                                <span>Tech Communities</span>
                            </li>
                            <li class="feature-item">
                                <mat-icon class="checkmark-icon">check</mat-icon>
                                <span>Visual Studio</span>
                            </li>
                            <li class="feature-item">
                                <mat-icon class="checkmark-icon">check</mat-icon>
                                <span>Learning Center</span>
                            </li>
                            <li class="feature-item">
                                <mat-icon class="checkmark-icon">check</mat-icon>
                                <span>Labs</span>
                            </li>
                        </ul>
                    </div>
                    <mat-divider [vertical]="true" class="card-divider"></mat-divider>
                    <div class="card-right-section">
                        <p class="section-title">Alumni</p>
                        <p class="section-subtitle">Free</p>
                        <ul class="feature-list">
                            <li class="feature-item">
                                <mat-icon class="checkmark-icon">check</mat-icon>
                                <span>Alumni network access</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </mat-card>

            <mat-card aria-labelledby="short-card-title" appearance="outlined">
                <div class="note-container">
                    <div class="note-icon">
                        <!-- <fa-icon></fa-icon> -->
                    </div>
                    <div class="note-content">
                        <div class="note-title">Need help?</div>
                        <div class="note-description">
                            <p>
                                If you have any questions or need assistance, our support team is here to help.
                            </p>
                            <p>
                                <a aria-label="Email MCT Support at mctpvsupport@pearson.com" href="mailto:mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a>
                            </p>
                        </div>
                    </div>
                </div>
            </mat-card>
        </div>

    </div>


    <div class="req-submitted-section" *ngIf="status == 'ACTIVE_MCT' && alumniStatus == 'APPROVAL'">
        <mat-card>
            <mat-card-title class="success-title">
                Alumni Request Approved Successfully
            </mat-card-title>

            <mat-card-content class="success-message-wrapper">
                <mat-divider class="success-devider"></mat-divider>
                <p>
                    Thank you for submitting your application to become an MCT Alumni.
                    <br />
                    Your application is approved, and you may continue to access the MCT Portal and the MCT Lounge as
                    part of your benefits through this program.
                    <br>
                    For questions, please contact us at
                    <a aria-label="Email MCT Support at mctpvsupport@pearson.com" href="mailto:mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a>
                    - we’re here to help!
                </p>
                <mat-divider class="success-devider"></mat-divider>

                <div>

                    <div class="subscription-details">
                        <div>
                            <p>ACTIVE SINCE</p>
                            <p>{{activeSince ? (activeSince | date:'MMMM dd, yyyy':'UTC' ): '-'}}</p>
                        </div>
                        <div>
                            <p>END DATE</p>
                            <p>{{endDate ? (endDate | date:'MMMM dd, yyyy':'UTC' ): '-'}}</p>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
    </ng-template>
</div>